import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { appUrl } from "./pages/app_props";
import { hydrateAuth, ensureFreshSession } from "./pages/authStorage";
import { installFetchAuthGuard } from "./pages/apiGuard";

// Catch backend 401s app-wide and re-run the OAuth flow (see apiGuard.js).
installFetchAuthGuard();

hydrateAuth();
const redirecting = ensureFreshSession(appUrl);

if (!redirecting) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
reportWebVitals();
